import { Component, OnInit } from '@angular/core';
declare var $: any;
import { ActivatedRoute } from "@angular/router";
import { AdminService } from 'app/services/admin/AdminService';


@Component({
  selector: 'app-new-email-template',
  templateUrl: './new-email-template.component.html',
  styleUrls: ['./new-email-template.component.scss']
})
export class NewEmailTemplateComponent implements OnInit {
    name: string;
    purpose: string;
    type: string;
    niche: string;
    fieldsOpen: boolean = true;
    fieldsModified: boolean = false;

    purposes: string[] =
    [
        "Invitation",
        "Reminder",
        "Result"
    ];

    types: string[] =
    [
        "Regular",
        "360"
    ];

    niches: string[] =
    [
        "General",
        "Business",
        "Sports"
    ];

    constructor(
        private _AdminService: AdminService,
        private activatedRoute: ActivatedRoute
    )
    {
        this.activatedRoute.params.subscribe(params => {
            console.log('params', params);
            this.name = params['name'];
            this.purpose = params['purpose'];
            this.type = params['type'];
            this.niche = params['niche'];
            console.log('name',this.name);
        });
    }



  ngOnInit() {
      //this.newCustomButton('address-book','student', 'Student Name', '{Student Name}');
      //this.newCustomButton('address-book','coach', 'Coach Name', '{Coach Name}');
      //this.newCustomButton('archive','niche', 'Niche', '{Niche}');
      //this.newCustomButton('link', 'report', 'Report URL', '{Report URL}');
      this.newCustomDropDown();
      //console.log("status", this.fieldsOpen);
      this.getTemplatePurposes();
    }

    getTemplatePurposes() {
        this._AdminService.getTemplatePurposes().subscribe((data: any) => {
            console.log('response_GetTemplatePurposes', data.result);
            this.purposes = JSON.parse(data.result.Data);
        });
    }

  //newCustomButton(iconName, ButtonName: string, title: string, htmlContent: string) {
  //    $.FroalaEditor.DefineIcon(ButtonName, { NAME: iconName });
  //    $.FroalaEditor.RegisterCommand(ButtonName, {
  //        title: title,
  //        focus: false,
  //        undo: false,
  //        refreshAfterCallback: false,

  //        callback: function () {
  //            this.html.insert(htmlContent);
  //        }
  //    });
  //}

  newCustomDropDown() {
      $.FroalaEditor.DefineIcon('my_dropdown', { NAME: 'plus-square' });
          $.FroalaEditor.RegisterCommand('my_dropdown', {
              title: 'Add Fields',
              type: 'dropdown',
              focus: false,
              undo: false,
              refreshAfterCallback: true,
              options: {
                  'student': 'Student Name',
                  'coach': 'Coach Name',
                  'niche': 'Niche',
                  'report': 'Report Url',
                  'ipeclogo': 'iPEC Logo',
                  'mylogo': 'My Logo'
              },
              callback: function (cmd, val) {
                  console.log(val);
                  switch (val) {
                      case 'student':
                          this.html.insert('{student name}');
                          break;
                      case 'coach':
                          this.html.insert('{coach name}');
                          break;
                      case 'niche':
                          this.html.insert('{niche}');
                          break;
                      case 'report':
                          this.html.insert('{report url}');
                          break;
                      case 'ipeclogo':
                          this.html.insert('{ipec logo}');
                          break;
                      case 'mylogo':
                          this.html.insert('{my logo}');
                          break;
                  }
              },
              // Callback on refresh.
              refresh: function (btn) {
                  console.log('do refresh', btn); 
                  $('.selector').on('froalaEditor.html.get', function (e, editor, html) {
                      console.log('html', html);
                      console.log('editor', editor);
                  });
              },
              // Callback on dropdown show.
              refreshOnShow: function ($btn, $dropdown) {
                  console.log('do refresh when show');
              }
          });
  }

  public options: Object = {
      charCounterCount: true,
      toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertVideo', 'embedly', 'insertFile', 'insertTable', '|', 'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'spellChecker', 'help', 'html', '|', 'undo', 'redo', 'my_dropdown']
  };

  changeTitle( status ) {
      
      this.fieldsOpen = !status;
      //console.log("status", this.fieldsOpen);
      if (this.name != undefined) {
          if (this.fieldsOpen) {
              $('.fieldsTitle a').text('Fields');
          } else {
              $('.fieldsTitle a').text('Fields - [' + this.type + ' | ' + this.niche + ' | ' + this.purpose + ']');
          }
      } else {
          if (this.fieldsModified) {
              if (this.fieldsOpen) {
                  $('.fieldsTitle a').text('Fields');
              } else {
                  if (this.type == undefined) {
                      this.type = this.types[0];
                  }
                  if (this.niche == undefined) {
                      this.niche = this.niches[0];
                  }
                  if (this.purpose == undefined) {
                      this.purpose = this.purposes[0];
                  }
                  $('.fieldsTitle a').text('Fields - [' + this.type + ' | ' + this.niche + ' | ' + this.purpose + ']');
              }
          } else {

              if (this.fieldsOpen) {
                  $('.fieldsTitle a').text('Fields');
              } else {
                  $('.fieldsTitle a').text('Fields - [' + this.types[0] + ' | ' + this.niches[0] + ' | ' + this.purposes[0] + ']');
              }
          }
      }

  }

  modifiedFields() {
      this.fieldsModified = true;
  }

  changeType(type: string) {
      this.type = type;
      this.modifiedFields();
  }

  changeNiche(niche: string) {
      this.niche = niche;
      this.modifiedFields();
  }

  changePurpose(purpose: string) {
      this.purpose = purpose;
      this.modifiedFields();
  }


}
